var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center analytics-progress-wrapper"},[_c('el-progress',{attrs:{"percentage":Math.floor(_vm.progress)}}),_vm._v(" "),_c('i',{staticClass:"el-icon-loading loading-icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }